import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import manCry from 'assets/images/icons/dashboard/man-cry.svg'
import { Icon } from 'components/icons/icon'
import { Button } from 'components/ui/Button'
import { Sizes } from 'components/ui/Loader'

interface ExclusionData {
  title?: string;
  message?: string;
  icon?: string;
  coverageType?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  primaryButtonRoute?: string;
  secondaryButtonRoute?: string;
  showConditionalButton?: boolean;
  /** Raisons détaillées du refus (sorties MRI : kill questions, seuils bâtiments…). */
  reasons?: string[];
}

export const ExcludedCoveragePage: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const exclusionData: ExclusionData = location.state || {}

  const {
    message = "Nous sommes désolés, l'assuré n'est pas éligible à l'assurance chômage",
    icon = manCry,
    primaryButtonText = "Faire une simulation",
    secondaryButtonText = "Retour aux simulations",
    primaryButtonRoute = "/mes-simulations",
    secondaryButtonRoute = "/mes-simulations",
    reasons = [],
  } = exclusionData

  return (
    <div className="max-w-5xl mx-auto py-14 border shadow rounded-2xl bg-white mt-40">
      <div className="flex flex-col items-center">
        <div className='w-10'>
          <img src={icon} alt="exclusion-icon" />
        </div>
        <p className="mg-b25 mg-t25 font-18 lh-22 font-w700">
          {message}
        </p>
        {reasons.length > 0 && (
          <div className="mb-6 flex w-full max-w-xl flex-col gap-2">
            {reasons.map((reason) => (
              <p
                key={reason}
                className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-700"
              >
                {reason}
              </p>
            ))}
          </div>
        )}
        <div className='flex flex-col gap-4'>
          <Button
            size={Sizes.lg}
            color='secondary'
            onClick={() => navigate(primaryButtonRoute)}
          >
            {primaryButtonText}
            <Icon name="arrow-right-w" height="8" width="11" styles="cursor svg-white mg-l10" />
          </Button>
          <Button
            size={Sizes.lg}
            outline
            onClick={() => navigate(secondaryButtonRoute)}
          >
            {secondaryButtonText}
          </Button>
        </div>
      </div>
    </div>
  )
}
